import { Navigate, useLocation } from "react-router-dom";
import { ROUTE } from "../constants/routes";

const AttendanceInsightsRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`${ROUTE.MEDIUMS_ATTENDANCE}${search}`} replace />;
};

export default AttendanceInsightsRedirect;
